import Icon from '../components/Icon.vue'

Icon.register({
  mercury: {
    width: 288,
    height: 512,
    paths: [
      {
        d: 'M288 208C288 163.8 268.1 124.3 236.8 97.9 239.3 96.1 241.7 94.1 244 92.1 268.7 70.9 283.8 43.3 287.2 13.3 288.1 6.2 282.5 0 275.3 0H234.8C229 0 224.1 4.1 223 9.8 220.6 22.3 213.4 34.1 202.3 43.6 187 56.8 166.3 64 144 64S101 56.8 85.6 43.6C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-0.1 6.2 0.8 13.3 4.2 43.4 19.2 71 44 92.2 46.3 94.2 48.7 96.1 51.2 98 19.9 124.3 0 163.8 0 208 0 276.5 47.9 333.9 112 348.4V400H76C69.4 400 64 405.4 64 412V452C64 458.6 69.4 464 76 464H112V500C112 506.6 117.4 512 124 512H164C170.6 512 176 506.6 176 500V464H212C218.6 464 224 458.6 224 452V412C224 405.4 218.6 400 212 400H176V348.4C240.1 333.9 288 276.5 288 208zM64 208C64 163.9 99.9 128 144 128S224 163.9 224 208 188.1 288 144 288 64 252.1 64 208z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mercury.js
// module id = 0hk4
// module chunks = 144